import React, { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Carousel from '../components/Carousel';
import { sampleProducts } from '../data/products';

export default function ProductDetail({ addToCart }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = sampleProducts.find(p => p.id === parseInt(id));
  const [count, setCount] = useState(1);

  if (!product) {
    return (
      <div className="page-wrapper">
        <div className="container">
          <p>Product not found. <Link to="/order-products">Back to products</Link></p>
        </div>
      </div>
    );
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (addToCart) addToCart(product, count);
    navigate('/cart');
  };

  return (
    <div className="page-wrapper">
      <div className="container">
        <div className="card" style={{ marginBottom: '2rem' }}>
          {/* Header */}
          <div className="detail-header">
            <h3>{product.title}</h3>
            <p>by {product.author}</p>
          </div>

          <div className="card-body">
            <div style={{ marginBottom: '1rem' }}>
              <Link to="/order-products" className="btn btn-outline-primary btn-sm">
                ← View More
              </Link>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '2rem', alignItems: 'start' }}>
              {/* Left: images */}
              <div>
                <Carousel images={product.images} />
              </div>

              {/* Right: details */}
              <div>
                <div style={{ marginBottom: '1rem' }}>
                  <span className="badge">{product.category.name}</span>
                </div>

                <p style={{ color: 'rgba(0,0,0,0.5)', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
                  ISBN: {product.isbn}
                </p>

                <p style={{ fontSize: '0.9rem', marginBottom: '1rem', color: 'rgba(0,0,0,0.6)' }}>
                  List Price: <span style={{ textDecoration: 'line-through' }}>${product.listPrice.toFixed(2)}</span>
                </p>

                {/* Price table */}
                <div className="price-table" style={{ marginBottom: '1rem' }}>
                  <div className="price-cell">Quantity</div>
                  <div className="price-cell">1–50</div>
                  <div className="price-cell">51–100</div>
                  <div className="price-cell">100+</div>
                  <div className="price-value" style={{ color: 'rgba(0,0,0,0.5)', fontWeight: 600 }}>Price</div>
                  <div className="price-value">${product.price.toFixed(2)}</div>
                  <div className="price-value">${product.price50.toFixed(2)}</div>
                  <div className="price-value">${product.price100.toFixed(2)}</div>
                </div>

                {/* Description */}
                <div
                  style={{ color: 'var(--secondary)', lineHeight: 1.7, marginBottom: '1.5rem', fontSize: '0.95rem' }}
                  dangerouslySetInnerHTML={{ __html: product.description }}
                />

                {/* Add to cart form */}
                <form onSubmit={handleSubmit}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                    <div className="input-group" style={{ maxWidth: 160 }}>
                      <span className="input-group-text">Count</span>
                      <input
                        type="number"
                        className="form-control"
                        value={count}
                        min="1"
                        max="1000"
                        onChange={e => setCount(parseInt(e.target.value) || 1)}
                      />
                    </div>
                  </div>
                  <button type="submit" className="btn btn-primary" style={{ minWidth: 200 }}>
                    Add to Cart
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
